// src/api/accountApi.js
import { api } from "./client";

export const accountApi = {
  list: () => api.get("/accounts/"),
  get: (accountId) => api.get(`/accounts/${accountId}`),
  create: (payload) => api.post("/accounts/", payload),
  update: (accountId, payload) => api.put(`/accounts/${accountId}`, payload),
  deactivate: (accountId) => api.delete(`/accounts/${accountId}`),
  activate: (accountId) => api.post(`/accounts/${accountId}/activate`),

  // Replaces the user's whole account-scoped role set on this account in
  // one call (the backend also has single-role POST/DELETE
  // .../account-roles routes for granting or revoking just one role at a
  // time — no frontend page needs that granularity right now, so there's
  // no wrapper for it here). No roster/membership step either way — an
  // account-scoped role is granted directly, same as an org-wide grant,
  // just narrower (see AccountAggregate's own docstring for why Account
  // has no roster).
  setRoles: (accountId, userId, roleNames) =>
    api.put(`/accounts/${accountId}/account-roles/${userId}`, { role_names: roleNames }),
};
